import { Platform, StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getWindowDimensions } from '../Utils/Helpers';

export default StyleSheet.create({
  containerStyle: withTray => ({
    flex: 1,
    paddingHorizontal: 16.6,
    paddingBottom: withTray ? 120 : 32,
    ...Platform.select({
      ios: {
        marginTop: getWindowDimensions.height < 800 ? 5 : 20,
      },
      android: {
        marginTop: 20,
      },
    }),
  }),
  buttonStyle: {
    marginTop: 4,
    marginBottom: 22,
  },
  expiredAddOnsContainerStyle: {
    marginTop: 8.2,
  },
  fullErrorIconStyle: {
    marginTop: 120,
  },
  errorIconStyle: {
    marginTop: 40,
  },
  emptyCaseText: {
    fontSize: 16,
    lineHeight: 20,
    textAlign: 'center',
    marginHorizontal: 20,
    marginBottom: 31,
  },
  titleContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16.7,
  },
  titleTextStyle: {
    ...Fonts.type.bold,
    fontSize: 24,
    lineHeight: 32,
  },
  subTitleContainerStyle: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  subTitleTextStyle: {
    marginHorizontal: 9,
    color: Colors.vfRed,
    fontSize: 16.6,
    marginVertical: 4,
  },
  requestedAddOnsContainerStyle: {
    marginTop: 6,
  },
  displayChangeButtonContainer: {
    marginTop: 3,
  },
  recommendedStyle: {
    ...Platform.select({
      android: { marginTop: -2 },
    }),
  },
});
